import React, { useState } from 'react'
import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material'
import { Text } from '@trivie/ui-web/components/text'
import { color } from '@trivie/ui-web/theme'

interface RadioCardProps {
  selected: boolean
  onClick: () => void
  label: string
  description?: string
  children?: React.ReactNode
}

export const RadioCard: React.FC<RadioCardProps> = ({
  selected,
  onClick,
  label,
  description,
  children,
}) => {
  const [hovered, setHovered] = useState(false)

  const showHover = hovered && !selected

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...CONTAINER,
        borderColor: selected ? '#1B59F8' : showHover ? color.shade50 : color.shade30,
        backgroundColor: selected ? '#1B59F810' : showHover ? '#f5f5f5' : '#fff',
      }}
    >
      {selected ? (
        <RadioButtonChecked htmlColor={color.blue} fontSize="small" />
      ) : (
        <RadioButtonUnchecked htmlColor={color.shade50} fontSize="small" />
      )}
      <div style={{ flexDirection: 'column', display: 'flex', gap: 2, flex: 1 }}>
        <Text variant="body1Medium" text={label} />
        {description && (
          <Text style={{ color: color.shade70 }} variant="body2" text={description} />
        )}
        {children}
      </div>
    </div>
  )
}

const CONTAINER: React.CSSProperties = {
  border: '1px solid',
  borderRadius: 10,
  padding: 16,
  flex: 1,
  flexDirection: 'row',
  display: 'flex',
  gap: 12,
  alignItems: 'center',
  cursor: 'pointer',
}
